import {serviceResolver} from "@infonova/framework/lib/service/configuration/serviceResolver";
import {serviceIdentifier} from "@infonova/framework/lib/service/serviceIdentifier";

export function tenant(): string {
    return serviceResolver().getService(TenantServiceIdentifier);
}

export const TenantServiceIdentifier = serviceIdentifier<string>('tenant');
